import Vue from 'vue';
import Vuex from 'vuex';
import login from '@/modules/login/store';
import auth from '@/store/auth';
import user from '@/store/user';
import criarConta from '@/store/criar-conta';
import listagemCotacao from '@/store/listagem-cotacao';
import listagemVendas from '@/store/listagem-vendas';
import listagemUsuario from '@/store/listagem-usuario';
import listagemProdutos from '@/store/listagem-produtos';
import listagemCatalogos from '@/store/listagem-catalogos';
import listagemOfertas from '@/store/listagem-ofertas';
import listagemConfiguracaoVenda from '@/store/listagem-configuracao-venda';
import listagemConfiguracaoFrete from '@/store/listagem-configuracao-frete';
import listagemMarketplaceOfertas from './listagem-marketplace-ofertas';
import listagemCompras from './listagem-compras';
import listagemGrade from './listagem-grades';
import listagemAlertas from './listagem-alertas';
import dashboardVendas from './dashboard-vendas';
import dashboardAcessos from './dashboard-acessos';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    login,
    auth,
    user,
    criarConta,
    listagemCotacao,
    listagemVendas,
    listagemUsuario,
    listagemProdutos,
    listagemCatalogos,
    listagemOfertas,
    listagemConfiguracaoVenda,
    listagemConfiguracaoFrete,
    listagemMarketplaceOfertas,
    listagemCompras,
    listagemGrade,
    listagemAlertas,
    dashboardVendas,
    dashboardAcessos,
  },
});
